/**
 * Every app config, grouped on disk by product suite (`safesystem/`, `mire/`,
 * `links/`, `speedmanagement/`) or `platform/` for shared tools.
 */

import type { AppConfig, AppId } from './types';
import { isAppAvailable } from './availability';
import { safecurvesConfig } from './safesystem/safecurves/config';
import { gisServicesConfig } from './platform/gis-services/config';
import { mireConfig } from './mire/ableymire/config';
import { saferoadsConfig } from './safesystem/saferoads/config';
import { safeintersectionsConfig } from './safesystem/safeintersections/config';
import { linksConfig } from './links/ableylinks/config';
import { nswRlgspConfig } from './speedmanagement/nsw-rlgsp/config';

// Array order drives UI listing order; per-app generics aren't mutually assignable, hence the widening.
export const APPS = [
	safecurvesConfig,
	gisServicesConfig,
	mireConfig,
	saferoadsConfig,
	safeintersectionsConfig,
	linksConfig,
	nswRlgspConfig
] as AppConfig<unknown>[];

// Every app by id, paired with whether this api key can use it; callers decide how to present unavailable ones.
export function getAppsWithAvailability(
	availableDatasets: ReadonlySet<string>,
	runtimeAvailability: Partial<Record<AppId, boolean>> = {}
) {
	return new Map(
		APPS.map((config) => [
			config.id,
			{
				config,
				available: isAppAvailable(config, availableDatasets, runtimeAvailability[config.id])
			}
		])
	);
}
